import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { IMAGES } from "constants/index"
import { copyButtonHandler } from "utils"
import {
  disconnectStripeAccount,
  getConnectedAccountsList,
  getStripeConnectedAccount,
  hideDisconnectStripeAccountModal,
  openDisconnectStripeAccountModal,
  setStripeMainAccount,
} from "store/actions"
import Select from "react-select"
import ModalComponent from "components/Modals"
import { SaveButton } from "components/Buttons"
import { stripe } from "config"

const PaymentTab = ({
  vendorId,
  getConnectedAccountsList,
  connectedAccountsList,
  setStripeMainAccount,
  disconnectStripeAccount,
  disconnectStripeAccountModalIsOpen,
  openDisconnectStripeAccountModal,
  hideDisconnectStripeAccountModal,
  loading,
  stripeConnectedAccount,
  getStripeConnectedAccount,
}) => {
  //TODO: change redirect url
  const redirect_url =
    "https://admin.dev.markedprivate.com/complete-stripe-connect"

  const stripe_url =
    "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=" +
    stripe.client_id +
    "&scope=read_write&state=" +
    vendorId +
    "&redirect_uri=" +
    redirect_url

  const [mainAcc, setMainAcc] = useState(null)
  const [customerStripeAccounts, setCustomerStripeAccounts] = useState([])
  const [selectedAccForDisconnect, setSelectedAccForDisconnect] = useState()
  const [disconnectMainAccWarningModal, setDisconnectMainAccWarningModal] =
    useState(false)

  useEffect(() => {
    // getConnectedAccountsList()
    getStripeConnectedAccount({ dashboard: true })
  }, [])

  // useEffect(() => {
  //   if (connectedAccountsList?.length > 0) {
  //     let customerAccounts = []
  //     for (let i = 0; i < connectedAccountsList?.length; i++) {
  //       if (connectedAccountsList[i]?.main_account === 1) {
  //         setMainAcc({
  //           value: connectedAccountsList[i]?.account_id,
  //           label: (
  //             <>
  //               <b>Name:</b> {connectedAccountsList[i]?.name} <b>ID:</b>{" "}
  //               {connectedAccountsList[i]?.account_id}
  //             </>
  //           ),
  //         })
  //       } else {
  //         customerAccounts.push(connectedAccountsList[i])
  //       }
  //     }
  //     setCustomerStripeAccounts(customerAccounts)
  //   }
  // }, [connectedAccountsList])

  return (
    <React.Fragment>
      <CardHeader className="mt-3">
        <h4>Payment Processing</h4>
      </CardHeader>
      <Card className="shadow-sm py-1">
        <CardBody>
          {!!stripeConnectedAccount && stripeConnectedAccount?.is_connected ? (
            <React.Fragment>
              <div>
                <span>
                  <b>Stripe: </b>
                </span>
                <span
                  style={{
                    backgroundColor: "#d3d6db",
                    fontSize: "14px",
                    padding: "5px",
                  }}
                >
                  account connected
                </span>
                <span className="ms-3 font-size-14">
                  (ID: {stripeConnectedAccount?.acc_id}, Name:{" "}
                  {stripeConnectedAccount?.acc_name})
                </span>
                <span
                  className="ms-1"
                  style={{
                    cursor: "pointer",
                    color: "#556ee6",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    setSelectedAccForDisconnect({
                      account_id: stripeConnectedAccount?.acc_id,
                    })
                    openDisconnectStripeAccountModal()
                  }}
                >
                  remove
                </span>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Row>
                <Col xs="auto" className="align-self-center">
                  Connect account:
                </Col>
                <Col xs="auto">
                  <div
                    className="mx-2"
                    onClick={() => {
                      window.open(stripe_url)
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={IMAGES.STRIPE_BUTTON} />
                  </div>
                </Col>
              </Row>
              {/* <Row className="my-3">
                <Col>
                  <span>
                    OR send this url to your customers so that they can connect
                    their own accounts:
                    {"  "}
                  </span>
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#556ee6",
                      textDecoration: "underline",
                    }}
                    onClick={() => {
                      copyButtonHandler(stripe_url)
                    }}
                  >
                    copy URL
                  </span>
                </Col>
              </Row> */}
            </React.Fragment>
          )}
        </CardBody>
      </Card>
      {/* {connectedAccountsList?.length > 0 && (
        <Card className="shadow-sm my-4">
          <CardBody>
            <Row>
              <Col>
                <h5>Select your Main Stripe Account:</h5>
              </Col>
            </Row>
            <Row className="my-2">
              <Col>
                <span className="font-size-14">
                  You are required to select your main account in order to be
                  able to receive payments. All the payments will by default go
                  into your main account, if you do not have payouts configured.
                  <br />
                  NOTE: All your connected accounts will display in the dropdown
                  immediately below, so please select YOUR Main Stripe Account.
                </span>
              </Col>
            </Row>
            <Row className="mt-4 mb-3">
              <Col>
                <h5>Select your Stripe Account:</h5>
              </Col>
            </Row>
            <Row>
              <Col xl={4}>
                <Select
                  value={mainAcc}
                  onChange={v => {
                    setStripeMainAccount(
                      {
                        account_id: v?.value,
                        vendor_id: vendorId,
                      },
                      () => getConnectedAccountsList()
                    )
                  }}
                  options={connectedAccountsList?.map(acc => ({
                    value: acc?.account_id,
                    label: (
                      <>
                        <b>Name:</b> {acc?.name} <b>ID:</b> {acc?.account_id}
                      </>
                    ),
                  }))}
                />
              </Col>
              {!!mainAcc && (
                <Col className="align-self-center" style={{ textAlign: "end" }}>
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#556ee6",
                      textDecoration: "underline",
                    }}
                    onClick={() => {
                      if (customerStripeAccounts?.length > 0) {
                        setDisconnectMainAccWarningModal(true)
                      } else {
                        setSelectedAccForDisconnect(acc)
                        openDisconnectStripeAccountModal()
                      }
                    }}
                  >
                    disconnect
                  </span>
                </Col>
              )}
            </Row>
          </CardBody>
        </Card>
      )}
      {customerStripeAccounts?.length > 0 && (
        <Card className="shadow-sm my-4">
          <CardBody>
            <Row className="mb-3">
              <Col>
                <h5>These are your Customers Connected Account(s):</h5>
              </Col>
            </Row>
            {customerStripeAccounts?.map(acc => {
              return (
                <Row className="my-3" key={acc?.account_id}>
                  <Col>
                    <b>Name:</b> {acc?.name} <b>ID:</b> {acc?.account_id}
                  </Col>
                  <Col xs="auto">
                    <span
                      style={{
                        cursor: "pointer",
                        color: "#556ee6",
                        textDecoration: "underline",
                      }}
                      onClick={() => {
                        setSelectedAccForDisconnect(acc)
                        openDisconnectStripeAccountModal()
                      }}
                    >
                      disconnect
                    </span>
                  </Col>
                </Row>
              )
            })}
          </CardBody>
        </Card>
      )} */}
      <ModalComponent
        open={disconnectStripeAccountModalIsOpen}
        title="Disconnect Stripe Account"
        onClose={hideDisconnectStripeAccountModal}
      >
        <Row>
          <Col>
            {selectedAccForDisconnect?.main_account ? (
              <h6>Are you sure you want to disconnect this account?</h6>
            ) : (
              <h6>
                Are you sure you want to disconnect this account? After doing
                this, you should check your configured payouts.
              </h6>
            )}
          </Col>
        </Row>
        <Row className="mt-2 justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="Cancel"
              onClick={hideDisconnectStripeAccountModal}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Disconnect"
              loading={loading}
              onClick={() => {
                disconnectStripeAccount({
                  account_id: selectedAccForDisconnect?.account_id,
                  vendor_id: vendorId,
                })
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        open={disconnectMainAccWarningModal}
        title="Disconnect Stripe Account"
        onClose={() => setDisconnectMainAccWarningModal(false)}
      >
        <Row>
          <Col>
            <h6>
              You can not disconnect your main account, you need to first select
              another account as the main one.
            </h6>
          </Col>
        </Row>
        <Row className="mt-2 justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="OK"
              onClick={() => setDisconnectMainAccWarningModal(false)}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  connectedAccountsList: state.Payouts.connectedAccountsList,
  disconnectStripeAccountModalIsOpen:
    state.Payouts.disconnectStripeAccountModalIsOpen,
  loading: state.Payouts.loading,
  stripeConnectedAccount: state.Payouts.stripeConnectedAccount,
})

const mapDispatchToProps = dispatch => ({
  getConnectedAccountsList: values =>
    dispatch(getConnectedAccountsList(values)),
  setStripeMainAccount: (values, callback) =>
    dispatch(setStripeMainAccount(values, callback)),
  openDisconnectStripeAccountModal: () =>
    dispatch(openDisconnectStripeAccountModal()),
  hideDisconnectStripeAccountModal: () =>
    dispatch(hideDisconnectStripeAccountModal()),
  disconnectStripeAccount: values => dispatch(disconnectStripeAccount(values)),
  getStripeConnectedAccount: values =>
    dispatch(getStripeConnectedAccount(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PaymentTab)
